(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-list"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initTnetCollections(section) {

    if (
      !section ||
      section.dataset.initialized === 'true'
    ) {
      return;
    }

    section.dataset.initialized = 'true';


    var searchInput =
      section.querySelector(
        '[data-collection-search]'
      );

    var cards =
      section.querySelectorAll(
        '[data-collection-card]'
      );

    var noResults =
      section.querySelector(
        '[data-collection-no-results]'
      );

    var resultCount =
      section.querySelector(
        '[data-collection-count]'
      );


    if (!searchInput) {
      return;
    }


    function updateResults() {

      var query =
        searchInput.value
          .trim()
          .toLowerCase();


      var visible =
        0;


      cards.forEach(function (card) {

        var title =
          card.dataset.collectionTitle || '';


        var matches =
          !query ||
          title.indexOf(query) !== -1;


        if (matches) {

          card.classList.remove(
            'is-hidden'
          );

          visible++;

        } else {

          card.classList.add(
            'is-hidden'
          );

        }

      });


      if (resultCount) {

        resultCount.textContent =
          visible +
          (
            visible === 1
              ? ' collection'
              : ' collections'
          );

      }


      if (noResults) {

        noResults.hidden =
          visible !== 0;

      }

    }


    searchInput.addEventListener(
      'input',
      updateResults
    );

  }


  function initAll() {

    document
      .querySelectorAll(
        '[data-tnet-collections]'
      )
      .forEach(
        initTnetCollections
      );

  }


  initAll();


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section =
        event.target.querySelector(
          '[data-tnet-collections]'
        );


      if (section) {

        initTnetCollections(
          section
        );

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnet-all-products"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initTnetCatalogue(section) {

    if (
      !section ||
      section.dataset.tnetInitialized === 'true'
    ) {
      return;
    }

    section.dataset.tnetInitialized = 'true';



    /* MOBILE FILTER */

    var filterPanel =
      section.querySelector(
        '[data-filter-panel]'
      );

    var filterOverlay =
      section.querySelector(
        '[data-filter-overlay]'
      );

    var openButton =
      section.querySelector(
        '[data-filter-open]'
      );

    var closeButton =
      section.querySelector(
        '[data-filter-close]'
      );


    function openFilters() {

      if (!filterPanel) {
        return;
      }

      filterPanel.classList.add(
        'is-open'
      );

      if (filterOverlay) {
        filterOverlay.classList.add(
          'is-open'
        );
      }

      if (openButton) {
        openButton.setAttribute(
          'aria-expanded',
          'true'
        );
      }

      document.body.classList.add(
        'tnet-filter-open'
      );

    }


    function closeFilters() {

      if (!filterPanel) {
        return;
      }

      filterPanel.classList.remove(
        'is-open'
      );

      if (filterOverlay) {
        filterOverlay.classList.remove(
          'is-open'
        );
      }

      if (openButton) {
        openButton.setAttribute(
          'aria-expanded',
          'false'
        );
      }

      document.body.classList.remove(
        'tnet-filter-open'
      );

    }


    if (openButton) {
      openButton.addEventListener(
        'click',
        openFilters
      );
    }


    if (closeButton) {
      closeButton.addEventListener(
        'click',
        closeFilters
      );
    }


    if (filterOverlay) {
      filterOverlay.addEventListener(
        'click',
        closeFilters
      );
    }


    document.addEventListener(
      'keydown',
      function (event) {

        if (event.key === 'Escape') {
          closeFilters();
        }

      }
    );



    /* FILTERING */

    var facetForm =
      section.querySelector(
        '[data-facet-form]'
      );


    if (facetForm) {

      var checkboxes =
        facetForm.querySelectorAll(
          'input[type="checkbox"][data-facet-input]'
        );


      checkboxes.forEach(
        function (input) {

          input.addEventListener(
            'change',
            function () {

              if (window.innerWidth > 749) {
                facetForm.submit();
              }

            }
          );

        }
      );

    }



    /* AJAX ADD TO CART */

    var productForms =
      section.querySelectorAll(
        '[data-product-form]'
      );


    productForms.forEach(
      function (form) {

        form.addEventListener(
          'submit',
          function (event) {

            event.preventDefault();


            var button =
              form.querySelector(
                '[data-add-to-cart]'
              );

            var label =
              form.querySelector(
                '[data-add-label]'
              );


            if (
              !button ||
              button.disabled
            ) {
              return;
            }


            button.disabled = true;


            if (label) {
              label.textContent =
                'Adding...';
            }


            var formData =
              new FormData(form);


            fetch(
              window.Shopify.routes.root +
              'cart/add.js',
              {
                method: 'POST',

                headers: {
                  'Accept':
                    'application/json'
                },

                body: formData
              }
            )

              .then(
                function (response) {

                  if (!response.ok) {
                    throw new Error(
                      'Unable to add product'
                    );
                  }

                  return response.json();

                }
              )

              .then(
                function (item) {

                  if (label) {
                    label.textContent =
                      'Added';
                  }


                  document.dispatchEvent(
                    new CustomEvent(
                      'cart:refresh',
                      {
                        bubbles: true,

                        detail: {
                          product: item
                        }
                      }
                    )
                  );


                  document.dispatchEvent(
                    new CustomEvent(
                      'cart:updated',
                      {
                        bubbles: true,

                        detail: {
                          product: item
                        }
                      }
                    )
                  );


                  setTimeout(
                    function () {

                      if (label) {
                        label.textContent =
                          'Add to cart';
                      }

                      button.disabled = false;

                    },
                    1400
                  );

                }
              )

              .catch(
                function () {

                  if (label) {
                    label.textContent =
                      'Try again';
                  }


                  setTimeout(
                    function () {

                      if (label) {
                        label.textContent =
                          'Add to cart';
                      }

                      button.disabled = false;

                    },
                    1600
                  );

                }
              );

          }
        );

      }
    );


  }



  function initAllTnetCatalogues() {

    document
      .querySelectorAll(
        '[data-tnet-catalogue]'
      )
      .forEach(
        initTnetCatalogue
      );

  }


  initAllTnetCatalogues();



  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section =
        event.target.querySelector(
          '[data-tnet-catalogue]'
        );


      if (section) {

        initTnetCatalogue(
          section
        );

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnet-cart-recommendations"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initTnetRecommendations(section) {

    if (
      !section ||
      section.dataset.initialized === 'true'
    ) {
      return;
    }

    section.dataset.initialized = 'true';


    /* =====================================================
       ELEMENTS
    ====================================================== */

    var results =
      section.querySelector(
        '[data-recommendations-results]'
      );

    var loading =
      section.querySelector(
        '[data-recommendations-loading]'
      );

    var empty =
      section.querySelector(
        '[data-recommendations-empty]'
      );


    /* =====================================================
       EXISTING SERVER-RENDERED PRODUCTS
    ====================================================== */

    var existingCards =
      results
        ? results.querySelectorAll(
            '.tnet-recommendations__card'
          ).length
        : 0;

    /*
     * In the Theme Editor Shopify can return this section
     * with recommendation products already rendered.
     *
     * If those products already exist, do not show the
     * skeleton and do not make a second request.
     */
    if (
      existingCards > 0 ||
      section.dataset.hasRenderedResults === 'true'
    ) {

      if (loading) {
        loading.hidden = true;
      }

      if (empty) {
        empty.hidden = true;
      }

      return;
    }


    /* =====================================================
       DATA
    ====================================================== */

    var productId =
      section.dataset.productId;

    var recommendationsUrl =
      section.dataset.recommendationsUrl;

    var sectionId =
      section.dataset.sectionId;

    var productsToShow =
      Math.min(
        Math.max(
          Number(
            section.dataset.productsToShow || 6
          ),
          1
        ),
        10
      );


    if (
      !productId ||
      !recommendationsUrl ||
      !sectionId ||
      !results
    ) {

      if (loading) {
        loading.hidden = true;
      }

      return;
    }


    /* =====================================================
       BUILD URL
    ====================================================== */

    var url =
      recommendationsUrl +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      encodeURIComponent(productsToShow) +
      '&intent=related';


    /* =====================================================
       FETCH RECOMMENDATIONS
    ====================================================== */

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'text/html'
      }
    })
      .then(function (response) {

        if (!response.ok) {
          throw new Error(
            'Recommendation request failed.'
          );
        }

        return response.text();

      })

      .then(function (html) {

        var parser =
          new DOMParser();

        var documentFragment =
          parser.parseFromString(
            html,
            'text/html'
          );

        var returnedSection =
          documentFragment.querySelector(
            '[data-tnet-cart-recommendations]'
          );


        if (!returnedSection) {

          throw new Error(
            'Recommendation section was not returned.'
          );

        }


        var returnedResults =
          returnedSection.querySelector(
            '[data-recommendations-results]'
          );

        var returnedCards =
          returnedResults
            ? returnedResults.querySelectorAll(
                '.tnet-recommendations__card'
              ).length
            : 0;


        if (
          !returnedResults ||
          returnedCards === 0
        ) {

          if (loading) {
            loading.hidden = true;
          }

          if (empty) {
            empty.hidden = false;
          }

          return;
        }


        /*
         * Replace only the results region so the current
         * section header and Theme Editor settings remain.
         */
        results.innerHTML =
          returnedResults.innerHTML;

        section.dataset.hasRenderedResults =
          'true';


        if (loading) {
          loading.hidden = true;
        }

        if (empty) {
          empty.hidden = true;
        }

      })

      .catch(function (error) {

        console.error(
          'T-Net cart recommendations:',
          error
        );

        if (loading) {
          loading.hidden = true;
        }

        if (empty) {
          empty.hidden = false;
        }

      });

  }


  /* =======================================================
     INITIALIZE
  ======================================================== */

  function initAll(root) {

    var scope =
      root || document;

    if (
      scope.matches &&
      scope.matches(
        '[data-tnet-cart-recommendations]'
      )
    ) {

      initTnetRecommendations(
        scope
      );

    }

    if (scope.querySelectorAll) {

      scope
        .querySelectorAll(
          '[data-tnet-cart-recommendations]'
        )
        .forEach(
          initTnetRecommendations
        );

    }

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initAll(document);

      }
    );

  } else {

    initAll(document);

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
  ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAll(
        event.target
      );

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnet-header"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('[data-tnet-header]').forEach((header) => {

  if (header.dataset.tnetInitialized === 'true') return;

  header.dataset.tnetInitialized = 'true';


  /* MOBILE MENU */

  const mobileButton =
    header.querySelector('[data-mobile-menu]');

  const mobilePanel =
    header.querySelector('[data-mobile-panel]');


  const setMobileOpen = (open) => {

    header.setAttribute(
      'data-mobile-open',
      open ? 'true' : 'false'
    );

    if (mobileButton) {

      mobileButton.setAttribute(
        'aria-expanded',
        open ? 'true' : 'false'
      );

      mobileButton.setAttribute(
        'aria-label',
        open ? 'Close menu' : 'Open menu'
      );

    }

  };


  if (mobileButton && mobilePanel) {

    mobileButton.addEventListener('click', () => {

      const isOpen =
        header.getAttribute('data-mobile-open') === 'true';

      setMobileOpen(!isOpen);

    });


    mobilePanel.querySelectorAll('a').forEach((link) => {

      link.addEventListener('click', () => {

        setMobileOpen(false);

      });

    });


    document.addEventListener('keydown', (event) => {

      if (event.key === 'Escape') {

        setMobileOpen(false);

      }

    });

  }


  /* PREDICTIVE SEARCH */

  const currency =
    header.dataset.currency || 'ZAR';

  const shopifyRoot =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';


  const escapeHtml = (value = '') => {

    const div =
      document.createElement('div');

    div.textContent =
      String(value);

    return div.innerHTML;

  };


  const formatMoney = (value) => {

    const number =
      Number(value);

    if (!Number.isFinite(number)) {

      return '';

    }

    try {

      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2
      }).format(number);

    } catch (error) {

      return `${currency} ${number.toFixed(2)}`;

    }

  };


  const searchComponents =
    header.querySelectorAll('[data-predictive-search]');


  searchComponents.forEach((component) => {

    const input =
      component.querySelector('[data-predictive-search-input]');

    const results =
      component.querySelector('[data-predictive-search-results]');

    const form =
      component.querySelector('form');


    if (!input || !results || !form) {

      return;

    }


    let controller =
      null;

    let debounceTimer =
      null;

    let activeIndex =
      -1;


    const getInteractiveItems = () => {

      return Array.from(
        results.querySelectorAll(
          '.tnet-predictive-search__item, .tnet-predictive-search__view-all'
        )
      );

    };


    const clearActiveItem = () => {

      getInteractiveItems().forEach((item) => {

        item.classList.remove('is-active');

      });

      activeIndex =
        -1;

    };


    const closeResults = () => {

      results.hidden =
        true;

      results.innerHTML =
        '';

      input.setAttribute(
        'aria-expanded',
        'false'
      );

      clearActiveItem();

    };


    const openResults = () => {

      results.hidden =
        false;

      input.setAttribute(
        'aria-expanded',
        'true'
      );

    };


    const renderLoading = () => {

      results.innerHTML =
        '<div class="tnet-predictive-search__loading">Searching products…</div>';

      openResults();

    };


    const renderResults = (products, query) => {

      const safeQuery =
        escapeHtml(query);


      if (!products || products.length === 0) {

        results.innerHTML = `
          <div class="tnet-predictive-search__empty">
            No products found for “${safeQuery}”.
          </div>

          <div class="tnet-predictive-search__footer">
            <a
              class="tnet-predictive-search__view-all"
              href="${shopifyRoot}search?q=${encodeURIComponent(query)}&type=product"
            >
              <span>Search all products</span>
              <span aria-hidden="true">→</span>
            </a>
          </div>
        `;

        openResults();

        return;

      }


      const productMarkup =
        products.map((product) => {

          const productTitle =
            escapeHtml(product.title || '');

          const productVendor =
            escapeHtml(product.vendor || '');

          const productUrl =
            escapeHtml(product.url || '#');

          const productImage =
            product.image
              ? escapeHtml(product.image)
              : '';

          const productPrice =
            formatMoney(product.price);


          const imageMarkup =
            productImage
              ? `
                <div class="tnet-predictive-search__image">
                  <img
                    src="${productImage}"
                    alt="${productTitle}"
                    loading="lazy"
                  >
                </div>
              `
              : `
                <div class="tnet-predictive-search__image">
                  <span class="tnet-predictive-search__image-placeholder">
                    TNET
                  </span>
                </div>
              `;


          return `
            <a
              href="${productUrl}"
              class="tnet-predictive-search__item"
              role="option"
            >
              ${imageMarkup}

              <div class="tnet-predictive-search__info">

                <span class="tnet-predictive-search__title">
                  ${productTitle}
                </span>

                ${
                  productVendor
                    ? `
                      <span class="tnet-predictive-search__vendor">
                        ${productVendor}
                      </span>
                    `
                    : ''
                }

              </div>

              ${
                productPrice
                  ? `
                    <span class="tnet-predictive-search__price">
                      ${productPrice}
                    </span>
                  `
                  : ''
              }

            </a>
          `;

        }).join('');


      results.innerHTML = `
        <div class="tnet-predictive-search__heading">
          Products
        </div>

        ${productMarkup}

        <div class="tnet-predictive-search__footer">

          <a
            class="tnet-predictive-search__view-all"
            href="${shopifyRoot}search?q=${encodeURIComponent(query)}&type=product"
          >
            <span>View all results for “${safeQuery}”</span>
            <span aria-hidden="true">→</span>
          </a>

        </div>
      `;


      clearActiveItem();

      openResults();

    };


    const performPredictiveSearch = async (query) => {

      if (controller) {

        controller.abort();

      }


      controller =
        new AbortController();


      const endpoint =
        `${shopifyRoot}search/suggest.json` +
        `?q=${encodeURIComponent(query)}` +
        `&resources[type]=product` +
        `&resources[limit]=6` +
        `&resources[limit_scope]=each` +
        `&resources[options][unavailable_products]=last`;


      renderLoading();


      try {

        const response =
          await fetch(endpoint, {
            signal: controller.signal,
            headers: {
              Accept: 'application/json'
            }
          });


        if (!response.ok) {

          throw new Error(
            `Predictive search failed: ${response.status}`
          );

        }


        const data =
          await response.json();


        const products =
          data &&
          data.resources &&
          data.resources.results &&
          Array.isArray(data.resources.results.products)
            ? data.resources.results.products
            : [];


        /*
         * Do not overwrite newer text with an older request.
         */
        if (input.value.trim() !== query) {

          return;

        }


        renderResults(
          products,
          query
        );

      } catch (error) {

        if (error.name === 'AbortError') {

          return;

        }


        console.error(
          'TNET predictive search error:',
          error
        );


        closeResults();

      }

    };


    input.addEventListener('input', () => {

      const query =
        input.value.trim();


      window.clearTimeout(
        debounceTimer
      );


      if (query.length < 2) {

        if (controller) {

          controller.abort();

        }

        closeResults();

        return;

      }


      debounceTimer =
        window.setTimeout(() => {

          performPredictiveSearch(query);

        }, 180);

    });


    input.addEventListener('focus', () => {

      const query =
        input.value.trim();


      if (
        query.length >= 2 &&
        results.innerHTML.trim() === ''
      ) {

        performPredictiveSearch(query);

      } else if (
        query.length >= 2 &&
        results.innerHTML.trim() !== ''
      ) {

        openResults();

      }

    });


    input.addEventListener('keydown', (event) => {

      const items =
        getInteractiveItems();


      if (event.key === 'Escape') {

        closeResults();

        input.blur();

        return;

      }


      if (
        results.hidden ||
        items.length === 0
      ) {

        return;

      }


      if (event.key === 'ArrowDown') {

        event.preventDefault();

        activeIndex =
          activeIndex < items.length - 1
            ? activeIndex + 1
            : 0;

      } else if (event.key === 'ArrowUp') {

        event.preventDefault();

        activeIndex =
          activeIndex > 0
            ? activeIndex - 1
            : items.length - 1;

      } else if (
        event.key === 'Enter' &&
        activeIndex >= 0 &&
        items[activeIndex]
      ) {

        event.preventDefault();

        items[activeIndex].click();

        return;

      } else {

        return;

      }


      items.forEach((item) => {

        item.classList.remove('is-active');

      });


      const activeItem =
        items[activeIndex];


      if (activeItem) {

        activeItem.classList.add('is-active');

        activeItem.scrollIntoView({
          block: 'nearest'
        });

      }

    });


    results.addEventListener('mousemove', () => {

      clearActiveItem();

    });


    document.addEventListener('click', (event) => {

      if (!component.contains(event.target)) {

        closeResults();

      }

    });


    form.addEventListener('submit', () => {

      closeResults();

    });

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnet-product-gallery"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initTnetProductGallery(section) {

    if (
      !section ||
      section.dataset.initialized === 'true'
    ) {
      return;
    }

    section.dataset.initialized = 'true';


    var slides =
      Array.from(
        section.querySelectorAll(
          '[data-gallery-slide]'
        )
      );


    var thumbnails =
      Array.from(
        section.querySelectorAll(
          '[data-gallery-thumbnail]'
        )
      );


    var previousButton =
      section.querySelector(
        '[data-gallery-prev]'
      );


    var nextButton =
      section.querySelector(
        '[data-gallery-next]'
      );


    var counter =
      section.querySelector(
        '[data-gallery-counter]'
      );


    var thumbnailContainer =
      section.querySelector(
        '[data-gallery-thumbnails]'
      );


    var thumbnailPrevious =
      section.querySelector(
        '[data-gallery-thumb-prev]'
      );


    var thumbnailNext =
      section.querySelector(
        '[data-gallery-thumb-next]'
      );


    if (!slides.length) {
      return;
    }


    var currentIndex = 0;


    function showSlide(index) {

      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }


      currentIndex = index;


      slides.forEach(
        function (slide, slideIndex) {

          var active =
            slideIndex === currentIndex;

          slide.classList.toggle(
            'is-active',
            active
          );

          slide.hidden = !active;

        }
      );


      thumbnails.forEach(
        function (thumbnail, thumbnailIndex) {

          var active =
            thumbnailIndex === currentIndex;

          thumbnail.classList.toggle(
            'is-active',
            active
          );

          thumbnail.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );

        }
      );


      if (counter) {

        counter.textContent =
          (currentIndex + 1) +
          ' / ' +
          slides.length;

      }


      if (thumbnails[currentIndex]) {

        thumbnails[currentIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });

      }

    }


    if (previousButton) {

      previousButton.addEventListener(
        'click',
        function () {

          showSlide(
            currentIndex - 1
          );

        }
      );

    }


    if (nextButton) {

      nextButton.addEventListener(
        'click',
        function () {

          showSlide(
            currentIndex + 1
          );

        }
      );

    }


    thumbnails.forEach(
      function (thumbnail) {

        thumbnail.addEventListener(
          'click',
          function () {

            var index =
              parseInt(
                thumbnail.dataset.galleryThumbnail,
                10
              );

            showSlide(index);

          }
        );

      }
    );


    if (thumbnailPrevious && thumbnailContainer) {

      thumbnailPrevious.addEventListener(
        'click',
        function () {

          thumbnailContainer.scrollBy({
            left: -300,
            behavior: 'smooth'
          });

        }
      );

    }


    if (thumbnailNext && thumbnailContainer) {

      thumbnailNext.addEventListener(
        'click',
        function () {

          thumbnailContainer.scrollBy({
            left: 300,
            behavior: 'smooth'
          });

        }
      );

    }


    document.addEventListener(
      'keydown',
      function (event) {

        if (
          !section.contains(
            document.activeElement
          )
        ) {
          return;
        }


        if (event.key === 'ArrowLeft') {

          showSlide(
            currentIndex - 1
          );

        }


        if (event.key === 'ArrowRight') {

          showSlide(
            currentIndex + 1
          );

        }

      }
    );


    var touchStartX = 0;

    var touchEndX = 0;


    var mainGallery =
      section.querySelector(
        '.tnet-product-gallery__main'
      );


    if (mainGallery) {

      mainGallery.addEventListener(
        'touchstart',
        function (event) {

          touchStartX =
            event.changedTouches[0].screenX;

        },
        {
          passive: true
        }
      );


      mainGallery.addEventListener(
        'touchend',
        function (event) {

          touchEndX =
            event.changedTouches[0].screenX;


          var distance =
            touchEndX - touchStartX;


          if (Math.abs(distance) < 40) {
            return;
          }


          if (distance < 0) {

            showSlide(
              currentIndex + 1
            );

          } else {

            showSlide(
              currentIndex - 1
            );

          }

        },
        {
          passive: true
        }
      );

    }

  }


  function initAll() {

    document
      .querySelectorAll(
        '[data-tnet-product-gallery]'
      )
      .forEach(
        initTnetProductGallery
      );

  }


  initAll();


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section =
        event.target.querySelector(
          '[data-tnet-product-gallery]'
        );

      if (section) {
        initTnetProductGallery(section);
      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnet-product-main"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initTnetProduct(section) {

    if (!section || section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';


    /* =====================================================
       ELEMENTS
    ====================================================== */

    var mainImage =
      section.querySelector('[data-main-image]');

    var thumbnails =
      section.querySelectorAll('[data-thumbnail]');

    var previousButton =
      section.querySelector('[data-gallery-prev]');

    var nextButton =
      section.querySelector('[data-gallery-next]');

    var variantDataElement =
      section.querySelector('[data-product-variants]');

    var variantIdInput =
      section.querySelector('[data-variant-id]');

    var priceElement =
      section.querySelector('[data-product-price]');

    var availabilityElement =
      section.querySelector('[data-availability]');

    var addButton =
      section.querySelector('[data-add-to-cart]');

    var quantityInput =
      section.querySelector('[data-quantity]');

    var quantityMinus =
      section.querySelector('[data-quantity-minus]');

    var quantityPlus =
      section.querySelector('[data-quantity-plus]');

    var optionSelects =
      section.querySelectorAll('[data-option-select]');

    var skuElement =
      section.querySelector('[data-product-sku]');

    var stickyCart =
      section.querySelector('[data-tnet-sticky-cart]');

    var stickyBar =
      section.querySelector('[data-sticky-bar]');

    var stickyAddButton =
      section.querySelector('[data-sticky-add-to-cart]');

    var stickyButtonText =
      section.querySelector('[data-sticky-button-text]');

    var stickyPrice =
      section.querySelector('[data-sticky-price]');

    var stickyVariantTitle =
      section.querySelector('[data-sticky-variant-title]');

    var stickyImage =
      section.querySelector('[data-sticky-image]');

    var stickyQuantity =
      section.querySelector('[data-sticky-quantity]');

    var stickyQuantityWrap =
      section.querySelector('[data-sticky-quantity-wrap]');

    var purchaseArea =
      section.querySelector('[data-product-form]');


    /* =====================================================
       GALLERY
    ====================================================== */

    var currentImageIndex = 0;


    function setActiveImage(index) {

      if (!thumbnails.length || !mainImage) {
        return;
      }

      if (index < 0) {
        index = thumbnails.length - 1;
      }

      if (index >= thumbnails.length) {
        index = 0;
      }

      currentImageIndex = index;

      var thumbnail =
        thumbnails[index];

      var imageUrl =
        thumbnail.dataset.imageUrl;

      var imageAlt =
        thumbnail.dataset.imageAlt || 'Product image';

      mainImage.style.opacity = '0';

      window.setTimeout(function () {

        mainImage.src = imageUrl;
        mainImage.alt = imageAlt;
        mainImage.style.opacity = '1';

      }, 100);

      thumbnails.forEach(function (item) {

        item.classList.remove('is-active');

      });

      thumbnail.classList.add('is-active');

      thumbnail.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });

    }


    thumbnails.forEach(function (thumbnail) {

      thumbnail.addEventListener(
        'click',
        function () {

          var index =
            parseInt(
              thumbnail.dataset.imageIndex,
              10
            );

          setActiveImage(index);

        }
      );

    });


    if (previousButton) {

      previousButton.addEventListener(
        'click',
        function () {

          setActiveImage(
            currentImageIndex - 1
          );

        }
      );

    }


    if (nextButton) {

      nextButton.addEventListener(
        'click',
        function () {

          setActiveImage(
            currentImageIndex + 1
          );

        }
      );

    }


    /* =====================================================
       VARIANT DATA
    ====================================================== */

    var variants = [];


    if (variantDataElement) {

      try {

        variants =
          JSON.parse(
            variantDataElement.textContent
          );

      } catch (error) {

        console.error(
          'T-Net product variant data could not be parsed.',
          error
        );

      }

    }


    var moneyFormat =
      section.dataset.moneyFormat || '';


    var amountToken =
      '{' + '{amount}' + '}';

    var amountNoDecimalsToken =
      '{' + '{amount_no_decimals}' + '}';

    var amountWithSpacesToken =
      '{' + '{ amount }' + '}';

    var amountNoDecimalsWithSpacesToken =
      '{' + '{ amount_no_decimals }' + '}';


    function formatMoney(cents) {

      var numericCents =
        Number(cents);


      if (isNaN(numericCents)) {
        numericCents = 0;
      }


      var amount =
        (numericCents / 100).toFixed(2);


      var amountNoDecimals =
        Math.round(
          numericCents / 100
        );


      if (!moneyFormat) {

        return amount;

      }


      return moneyFormat
        .replace(
          amountToken,
          amount
        )
        .replace(
          amountWithSpacesToken,
          amount
        )
        .replace(
          amountNoDecimalsToken,
          amountNoDecimals
        )
        .replace(
          amountNoDecimalsWithSpacesToken,
          amountNoDecimals
        );

    }


    /* =====================================================
       STICKY ADD TO CART
    ====================================================== */

    function syncStickyQuantity() {

      if (!stickyQuantity) {
        return;
      }

      var quantity =
        quantityInput
          ? parseInt(quantityInput.value, 10) || 1
          : 1;

      stickyQuantity.textContent =
        quantity;

      if (stickyQuantityWrap) {

        stickyQuantityWrap.hidden =
          !stickyCart ||
          stickyCart.dataset.variantAvailable !== 'true' ||
          quantity <= 1;

      }

    }


    function syncStickyCart(variant) {

      if (!stickyCart || !variant) {
        return;
      }

      var available =
        Boolean(variant.available);

      stickyCart.dataset.variantAvailable =
        available ? 'true' : 'false';


      if (stickyAddButton) {

        stickyAddButton.disabled =
          !available;

      }


      if (stickyButtonText) {

        stickyButtonText.textContent =
          available
            ? 'Add to cart'
            : 'Sold out';

      }


      if (stickyPrice) {

        if (
          variant.compare_at_price &&
          Number(variant.compare_at_price) >
          Number(variant.price)
        ) {

          stickyPrice.innerHTML =
            '<span class="tnet-sticky-cart__price-current">' +
            formatMoney(variant.price) +
            '</span>' +

            '<span class="tnet-sticky-cart__price-compare">' +
            formatMoney(variant.compare_at_price) +
            '</span>';

        } else {

          stickyPrice.innerHTML =
            '<span class="tnet-sticky-cart__price-current">' +
            formatMoney(variant.price) +
            '</span>';

        }

      }


      if (stickyVariantTitle) {

        var variantTitle =
          variant.title || '';

        var isDefaultVariant =
          variantTitle === 'Default Title';

        stickyVariantTitle.textContent =
          isDefaultVariant
            ? ''
            : variantTitle;

        stickyVariantTitle.hidden =
          isDefaultVariant ||
          !variantTitle;

      }


      if (
        stickyImage &&
        variant.featured_image &&
        variant.featured_image.src
      ) {

        stickyImage.src =
          variant.featured_image.src;

        stickyImage.alt =
          variant.featured_image.alt ||
          stickyImage.alt ||
          'Product image';

      }


      syncStickyQuantity();


      if (
        !available &&
        stickyBar
      ) {

        stickyBar.dataset.stuck =
          'false';

      }

    }


    function setStickyCartVisible(visible) {

      if (!stickyBar || !stickyCart) {
        return;
      }

      var variantAvailable =
        stickyCart.dataset.variantAvailable === 'true';

      stickyBar.dataset.stuck =
        visible && variantAvailable
          ? 'true'
          : 'false';

    }


    /* =====================================================
       FIND SELECTED VARIANT
    ====================================================== */

    function getSelectedVariant() {

      if (!variants.length) {
        return null;
      }


      var selectedOptions = [];


      optionSelects.forEach(function (select) {

        selectedOptions.push(
          select.value
        );

      });


      if (!selectedOptions.length) {

        return variants.find(
          function (variant) {
            return variant.available;
          }
        ) || variants[0];

      }


      return variants.find(
        function (variant) {

          return variant.options.every(
            function (option, index) {

              return option === selectedOptions[index];

            }
          );

        }
      ) || null;

    }


    /* =====================================================
       UPDATE PRODUCT INFORMATION
    ====================================================== */

    function updateVariant() {

      var variant =
        getSelectedVariant();


      if (!variant) {
        return;
      }


      /* VARIANT ID */

      if (variantIdInput) {

        variantIdInput.value =
          variant.id;

      }


      /* PRICE */

      if (priceElement) {

        if (
          variant.compare_at_price &&
          Number(variant.compare_at_price) >
          Number(variant.price)
        ) {

          priceElement.innerHTML =
            '<span class="tnet-product__price-current">' +
            formatMoney(variant.price) +
            '</span>' +

            '<span class="tnet-product__price-compare">' +
            formatMoney(variant.compare_at_price) +
            '</span>' +

            '<span class="tnet-product__vat">' +
            'Incl. VAT' +
            '</span>';

        } else {

          priceElement.innerHTML =
            '<span class="tnet-product__price-current">' +
            formatMoney(variant.price) +
            '</span>' +

            '<span class="tnet-product__vat">' +
            'Incl. VAT' +
            '</span>';

        }

      }


      /* AVAILABILITY */

      if (availabilityElement) {

        if (variant.available) {

          availabilityElement.innerHTML =
            '<span class="tnet-product__availability-dot"></span>' +
            'In stock';

        } else {

          availabilityElement.innerHTML =
            '<span class="tnet-product__availability-dot tnet-product__availability-dot--out"></span>' +
            'Sold out';

        }

      }


      /* BUTTONS */

      if (addButton) {

        addButton.disabled =
          !variant.available;

        addButton.textContent =
          variant.available
            ? 'Add to cart'
            : 'Sold out';

      }


      /* SKU */

      if (skuElement) {

        skuElement.textContent =
          variant.sku || '';

      }


      /* STICKY CART */

      syncStickyCart(
        variant
      );


      /* VARIANT IMAGE */

      if (
        variant.featured_image &&
        variant.featured_image.src
      ) {

        var variantImage =
          variant.featured_image.src;


        var matchingThumbnailIndex =
          -1;


        thumbnails.forEach(
          function (thumbnail, index) {

            var thumbnailUrl =
              thumbnail.dataset.imageUrl;


            if (
              thumbnailUrl &&
              thumbnailUrl.indexOf(
                variantImage.split('?')[0]
              ) !== -1
            ) {

              matchingThumbnailIndex =
                index;

            }

          }
        );


        if (matchingThumbnailIndex >= 0) {

          setActiveImage(
            matchingThumbnailIndex
          );

        }

      }

    }


    /* =====================================================
       VARIANT SELECTS
    ====================================================== */

    optionSelects.forEach(function (select) {

      select.addEventListener(
        'change',
        function () {

          updateVariant();

        }
      );

    });


    /* =====================================================
       QUANTITY
    ====================================================== */

    if (quantityMinus) {

      quantityMinus.addEventListener(
        'click',
        function () {

          var current =
            parseInt(
              quantityInput.value,
              10
            ) || 1;


          if (current > 1) {

            quantityInput.value =
              current - 1;

          }

          syncStickyQuantity();

        }
      );

    }


    if (quantityPlus) {

      quantityPlus.addEventListener(
        'click',
        function () {

          var current =
            parseInt(
              quantityInput.value,
              10
            ) || 1;


          quantityInput.value =
            current + 1;

          syncStickyQuantity();

        }
      );

    }


    if (quantityInput) {

      quantityInput.addEventListener(
        'change',
        function () {

          var value =
            parseInt(
              quantityInput.value,
              10
            ) || 1;


          if (value < 1) {

            quantityInput.value =
              1;

          }

          syncStickyQuantity();

        }
      );

    }


    /* =====================================================
       STICKY CART INTERACTION
    ====================================================== */

    if (
      stickyAddButton &&
      purchaseArea
    ) {

      stickyAddButton.addEventListener(
        'click',
        function () {

          if (
            stickyAddButton.disabled ||
            !addButton
          ) {
            return;
          }

          if (
            typeof purchaseArea.requestSubmit === 'function'
          ) {

            purchaseArea.requestSubmit(
              addButton
            );

          } else {

            addButton.click();

          }

        }
      );

    }


    if (
      stickyCart &&
      stickyBar &&
      purchaseArea
    ) {

      var purchaseHasPassed =
        false;

      var footerIsVisible =
        false;


      function refreshStickyVisibility() {

        setStickyCartVisible(
          purchaseHasPassed &&
          !footerIsVisible
        );

      }


      var purchaseObserver =
        new IntersectionObserver(
          function (entries) {

            var entry =
              entries[0];

            if (!entry) {
              return;
            }

            purchaseHasPassed =
              !entry.isIntersecting &&
              entry.boundingClientRect.bottom < 0;

            refreshStickyVisibility();

          },
          {
            threshold: 0
          }
        );


      purchaseObserver.observe(
        purchaseArea
      );


      var footer =
        document.querySelector('footer') ||
        document.querySelector('[class*="footer-group"]');


      var footerObserver =
        null;


      if (footer) {

        footerObserver =
          new IntersectionObserver(
            function (entries) {

              var entry =
                entries[0];

              if (!entry) {
                return;
              }

              footerIsVisible =
                entry.isIntersecting;

              refreshStickyVisibility();

            },
            {
              rootMargin: '200px 0px 0px 0px',
              threshold: 0
            }
          );


        footerObserver.observe(
          footer
        );

      }


      section._tnetStickyDestroy =
        function () {

          purchaseObserver.disconnect();

          if (footerObserver) {
            footerObserver.disconnect();
          }

        };

    }


    if (
      stickyCart &&
      variantIdInput &&
      variants.length
    ) {

      var initialStickyVariant =
        variants.find(
          function (variant) {

            return String(variant.id) ===
              String(variantIdInput.value);

          }
        ) ||
        getSelectedVariant();


      if (initialStickyVariant) {

        syncStickyCart(
          initialStickyVariant
        );

      }

    } else {

      syncStickyQuantity();

    }

  }


  /* =======================================================
     INITIALIZE
  ======================================================== */

  function initAll() {

    document
      .querySelectorAll('[data-tnet-product]')
      .forEach(
        initTnetProduct
      );

  }


  initAll();


  /* =======================================================
     SHOPIFY THEME EDITOR
  ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section =
        event.target.querySelector(
          '[data-tnet-product]'
        );


      if (section) {

        initTnetProduct(
          section
        );

      }

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      var section =
        event.target.querySelector(
          '[data-tnet-product]'
        );


      if (
        section &&
        typeof section._tnetStickyDestroy === 'function'
      ) {

        section._tnetStickyDestroy();

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnet-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {

  function initTnetRecommendations(section) {

    if (!section || section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    var results = section.querySelector('[data-recommendations-results]');
    var loading = section.querySelector('[data-recommendations-loading]');
    var empty = section.querySelector('[data-recommendations-empty]');

    var existingCards = results
      ? results.querySelectorAll('.tnet-recommendations__card').length
      : 0;

    if (existingCards > 0) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = true;
      return;
    }

    var productId = section.dataset.productId;
    var recommendationsUrl = section.dataset.recommendationsUrl;
    var sectionId = section.dataset.sectionId;

    var productsToShow = Math.min(
      Math.max(Number(section.dataset.productsToShow || 6), 1),
      10
    );

    if (!productId || !recommendationsUrl || !sectionId || !results) {
      if (loading) loading.hidden = true;
      section.hidden = true;
      return;
    }

    function buildUrl(intent) {
      return (
        recommendationsUrl +
        '?section_id=' + encodeURIComponent(sectionId) +
        '&product_id=' + encodeURIComponent(productId) +
        '&limit=' + encodeURIComponent(productsToShow) +
        '&intent=' + encodeURIComponent(intent) +
        '&_tnet=' + Date.now()
      );
    }

    function fetchRecommendations(intent) {
      return fetch(buildUrl(intent), {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Accept': 'text/html'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              'Recommendation request failed for ' + intent + '.'
            );
          }
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var documentFragment = parser.parseFromString(html, 'text/html');
          var returnedSection = documentFragment.querySelector(
            '[data-tnet-cart-recommendations]'
          );

          if (!returnedSection) {
            return {
              intent: intent,
              cards: 0,
              html: ''
            };
          }

          var returnedResults = returnedSection.querySelector(
            '[data-recommendations-results]'
          );

          var returnedCards = returnedResults
            ? returnedResults.querySelectorAll('.tnet-recommendations__card').length
            : 0;

          return {
            intent: intent,
            cards: returnedCards,
            html: returnedResults ? returnedResults.innerHTML : ''
          };
        });
    }

    function renderRecommendations(payload) {
      results.innerHTML = payload.html;
      section.dataset.hasRenderedResults = 'true';
      section.dataset.recommendationIntent = payload.intent;
      section.hidden = false;

      if (loading) loading.hidden = true;
      if (empty) empty.hidden = true;
    }

    function hideSection() {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = true;
      section.hidden = true;
    }

    function loadRelatedFallback() {
      return fetchRecommendations('related')
        .then(function (relatedPayload) {
          if (relatedPayload.cards > 0) {
            renderRecommendations(relatedPayload);
            return;
          }

          hideSection();
        });
    }

    /*
     * Priority:
     * 1. Manually configured complementary products.
     * 2. Shopify's automatically generated related recommendations.
     * 3. Hide the section if neither strategy returns anything.
     */
    fetchRecommendations('complementary')
      .then(function (complementaryPayload) {
        if (complementaryPayload.cards > 0) {
          renderRecommendations(complementaryPayload);
          return;
        }

        return loadRelatedFallback();
      })
      .catch(function (complementaryError) {
        console.warn(
          'T-Net complementary recommendations failed; trying related products.',
          complementaryError
        );

        return loadRelatedFallback().catch(function (relatedError) {
          console.error(
            'T-Net related recommendations also failed.',
            relatedError
          );
          hideSection();
        });
      });
  }

  function initAll(root) {
    var scope = root || document;

    if (
      scope.matches &&
      scope.matches('[data-tnet-cart-recommendations]')
    ) {
      initTnetRecommendations(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll('[data-tnet-cart-recommendations]')
        .forEach(initTnetRecommendations);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  /*
   * Safari can restore pages from the back-forward cache. Re-check the
   * recommendation section after a persisted page is restored.
   */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;

    document
      .querySelectorAll('[data-tnet-cart-recommendations]')
      .forEach(function (section) {
        section.dataset.initialized = 'false';
        initTnetRecommendations(section);
      });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnet-search-results"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initTnetSearch(section) {

    if (!section || section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    var filterToggle = section.querySelector('[data-filter-toggle]');
    var filterContainer = section.querySelector('.tnet-search__mobile-filter');
    var filterContent = section.querySelector('[data-filter-content]');

    if (filterToggle && filterContainer && filterContent) {
      filterToggle.addEventListener('click', function () {
        var isOpen = filterContainer.classList.toggle('is-open');
        filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    var sortSelect = section.querySelector('[data-search-sort]');
    var searchAgain = section.querySelector('[data-search-again]');

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    if (searchAgain) {
      searchAgain.addEventListener('click', function (event) {
        event.preventDefault();

        var target = section.querySelector('.tnet-search__input');

        if (target) {
          target.focus();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    }

  }


  function initAll(root) {

    var scope = root || document;

    if (scope.matches && scope.matches('[data-tnet-search]')) {
      initTnetSearch(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll('[data-tnet-search]')
        .forEach(initTnetSearch);
    }

  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }


  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

})();


  } catch(e) { console.error(e); }
})();
})();
